import { Inbox, Search, FileX } from "lucide-react";
import { Button } from "@/ui/atoms";
import { cn } from "@/utils/utils";

export type TEmptyStateVariant = "default" | "search" | "error";

export interface TEmptyStateProps {
    variant?: TEmptyStateVariant;
    title: string;
    description?: string;
    action?: {
        label: string;
        onClick: () => void;
    };
    className?: string;
}

const icons: Record<TEmptyStateVariant, typeof Inbox> = {
    default: Inbox,
    search: Search,
    error: FileX,
};

export function EmptyState({
    variant = "default",
    title,
    description,
    action,
    className,
}: TEmptyStateProps) {
    const Icon = icons[variant];

    return (
        <div
            className={cn(
                "flex flex-col items-center justify-center py-12 px-4 text-center",
                className,
            )}
        >
            <div className="mb-4 rounded-full bg-muted p-4">
                <Icon className="h-8 w-8 text-muted-foreground" />
            </div>
            <h3 className="text-lg font-semibold">{title}</h3>
            {description && (
                <p className="mt-1 text-sm text-muted-foreground max-w-sm">{description}</p>
            )}
            {action && (
                <Button onClick={action.onClick} className="mt-4">
                    {action.label}
                </Button>
            )}
        </div>
    );
}
